import { useState, useRef, useEffect } from "react";
import { Form } from "antd";

export function useGlobalState() {
  const [currentLocation, setCurrentLocation] = useState(null);
  const [tempLocation, setTempLocation] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentRadius, setCurrentRadius] = useState(5);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showChangeLocationModal, setShowChangeLocationModal] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [showUserStatus, setShowUserStatus] = useState(false);
  const [currentNumber, setCurrentNumber] = useState(0);
  const [queueStatus, setQueueStatus] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpResendTimer, setOtpResendTimer] = useState(false);
  const [otpTimerCount, setOtpTimerCount] = useState(30);
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const [businessName, setBusinessName] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [queueData, setQueueData] = useState([]);
  const [showCustomBusinessType, setShowCustomBusinessType] = useState(false);
  const [customBusinessType, setCustomBusinessType] = useState("");
  const [showUpdateProfileModal, setShowUpdateProfileModal] = useState(false);
  const [typeOfBusinesses, setTypeOfBusinesses] = useState([]);
  const [userId, setUserId] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [businessDetails, setBusinessDetails] = useState(false);
  const [businessMessage, setBusinessMessage] = useState({});
  const [contactUsVisible, setContactUsVisible] = useState(false);
  const [faqVisible, setFaqVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const [profileForm] = Form.useForm();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  const isLoggedInRef = useRef(isLoggedIn);
  const userIdRef = useRef(userId);
  const selectedBusinessTypeRef = useRef(selectedBusinessType);
  const socketRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    isLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn]);

  useEffect(() => {
    userIdRef.current = userId;
  }, [userId]);

  useEffect(() => {
    selectedBusinessTypeRef.current = selectedBusinessType;
  }, [selectedBusinessType]);

  return {
    currentLocation, setCurrentLocation,
    tempLocation, setTempLocation,
    isLoggedIn, setIsLoggedIn,
    currentRadius, setCurrentRadius,
    showLocationModal, setShowLocationModal,
    showChangeLocationModal, setShowChangeLocationModal,
    showSidebar, setShowSidebar,
    showAuthModal, setShowAuthModal,
    authMode, setAuthMode,
    showAlertModal, setShowAlertModal,
    showUserStatus, setShowUserStatus,
    currentNumber, setCurrentNumber,
    queueStatus, setQueueStatus,
    showVerificationModal, setShowVerificationModal,
    otpSent, setOtpSent,
    otpResendTimer, setOtpResendTimer,
    otpTimerCount, setOtpTimerCount,
    otp, setOtp,
    otpVerified, setOtpVerified,
    showResetPasswordModal, setShowResetPasswordModal,
    loading, setLoading,
    selectedBusinessType, setSelectedBusinessType,
    businessName, setBusinessName,
    isMobile, setIsMobile,
    queueData, setQueueData,
    showCustomBusinessType, setShowCustomBusinessType,
    customBusinessType, setCustomBusinessType,
    showUpdateProfileModal, setShowUpdateProfileModal,
    typeOfBusinesses, setTypeOfBusinesses,
    userId, setUserId,
    userAddress, setUserAddress,
    buttonLoading, setButtonLoading,
    detailsModal, setDetailsModal,
    businessDetails, setBusinessDetails,
    businessMessage, setBusinessMessage,
    contactUsVisible, setContactUsVisible,
    faqVisible, setFaqVisible,
    searchValue, setSearchValue,
    
    profileForm, form1, form2,
    isLoggedInRef, userIdRef, selectedBusinessTypeRef, socketRef, timeoutRef
  };
}
